import { GenericConfig } from "@signature-it/ngx-generic/config";
import { AbstractDTO } from "@signature-it/ngx-generic/models";
import { EncodeSeoUriPipe } from '@signature-it/ngx-catalogue/pipes';
import {CatalogueTypes} from "@signature-it/ngx-catalogue/enums";

export class Group extends AbstractDTO {
	id: number;
	name: string;
	idx: number;
	children: Array<Group>;
    type: string;
    parent: number;
    parent_slug: string;
    lft: number;
    level: number;
    slug: string;
    category_mode: number;
    display_type: string;
    modificationTimestamp: string;
    isleaf: boolean;
	ngxComponent: string;
	ngxComponentPosition: number;
	ngxBoxSize: number;
    description: string;
    SEOTitle: string;
    SEODescription: string;
    count: number;
    ignoreBreadcrumbs: number;
    taxonomyVar: string;
    entityVar: string;
    entityUri: string;
    taxonomyUri: string;
    parentVar: string;
    parentUri: string;
    catalogueUrl: string;
    catalogueFriendlyUrl: string;
    private _gPic: string;
    private _baseImgPath = `images/Fittings/${GenericConfig.systemName}/Group_Images`;
    isRoot: boolean;
    doc: any; // additional data for taxonomy group
    requestedDoc: boolean // if group.requestedDoc is true, we are not going to search docs in solr again
    idParam: string;

    constructor(attributes: object, isRoot = false) {
        super(attributes);
        attributes = attributes ? attributes : {};

        this.id = parseInt(attributes['id']) || -1;
        this.idx = parseInt(attributes['idx']) || 99999;
        this.name = attributes['name'] || '';
        this.isRoot = isRoot;
        this.taxonomyVar = attributes['taxonomyVar'];
        this.taxonomyUri = attributes['taxonomyUri'];
        if(attributes['children']) {
            this.children = Group.createFromArray(attributes['children'].map(c => {c.taxonomyVar = this.taxonomyVar; c.taxonomyUri = this.taxonomyUri; return c;})).sort((a: Group, b: Group) => a.idx - b.idx);
        }
        this.isleaf = attributes['isleaf'] == '1' ? true: false;
        this.parent = attributes['parent'] ? Number(attributes['parent']) : 0;
        this.category_mode = attributes['category_mode'] || 0;
        this.display_type = attributes['display_type'] || '';
        this.ngxComponent = attributes['ngx_component'] || '';
        this.ngxComponentPosition = attributes['ngx_component_position'] || 0;
        this.ngxBoxSize = attributes['ngx_box_size'] || 1;
        this.description = attributes['description'] || '';
        this.SEOTitle = attributes['SEOTitle'] || '';
        this.SEODescription = attributes['SEODescription'] || '';
        this.count = 0;
        this.ignoreBreadcrumbs = attributes['ignore_breadcrumbs'] || 0;
        this.entityVar = attributes['entity_var'];
        this.entityUri = attributes['entity_uri'];
        this.parentVar = attributes['parent_var'];
        this.parentUri = attributes['parent_uri'];
        this.slug = GenericConfig.rootGroupSlug && isRoot ? GenericConfig.rootGroupSlug : attributes['slug'] || '';
        this.parent_slug = attributes['parent_slug'] || this.parentVar || '';
        this.catalogueUrl = this.taxonomyVar ? `${CatalogueTypes.TAXONOMY}/${this.taxonomyUri}` : 'catalogue/group';
        this.catalogueFriendlyUrl = this.taxonomyVar ? this.catalogueUrl : 'catalogue';
        this.idParam = this.taxonomyVar ? 'entityUri' : 'id';
        this.doc = attributes['doc'];
        this.requestedDoc = attributes['requestedDoc'];
        this.gPic = attributes['gpic'];
    }

    getUrl(familyName?) {
        if (this.isRoot && GenericConfig.breadcrumbsCatalogHomeURL) {
            return GenericConfig.breadcrumbsCatalogHomeURL;
        }
        if (GenericConfig.disable_friendly_url) {
            if (this.isleaf) {
                if (familyName) {
                    return `/${this.catalogueUrl}/${this[this.idParam]}/${this.slug.replace(/\//g, '%2F')}/${familyName}`;
                }
                return `/${this.catalogueUrl}/${this[this.idParam]}/${this.slug.replace(/\//g, '%2F')}`;
            }
            if (!GenericConfig.doNotRedirectSingleGroup && this.children?.length == 1) {
                return this.children[0].getUrl();
            }
            return `/${this.catalogueUrl}/${this[this.idParam]}`;
        }
        const encodeSeoUri = new EncodeSeoUriPipe();
        const groupName = encodeURIComponent(encodeSeoUri.transform(this.slug));
        if (this.isleaf) {
            const parentGroupName = encodeURIComponent(encodeSeoUri.transform(this.parent_slug));
            if (familyName) {
                return `/${this.catalogueFriendlyUrl}/${parentGroupName}/${groupName}/${this.encodeURI(familyName)}`;
            }
            return `/${this.catalogueFriendlyUrl}/${parentGroupName}/${groupName}`;
        }
        return `/${this.catalogueFriendlyUrl}/${groupName}`;
    }

    encodeURI(str: string): string {
        return str.replace(/[!'()*]/g, (c) => {
            return '%' + c.charCodeAt(0).toString(16);
        });
    }

    set gPic(value) {
        if(GenericConfig.multiExtensionImageGroup && Array.isArray(GenericConfig.multiExtensionImageGroup) && this.taxonomyVar) {
            this._gPic = `${value}.${GenericConfig.multiExtensionImageGroup[0]}`;
        } else {
            this._gPic = this.taxonomyVar ?
                (value ? `/images/Fittings/${value}_Med.jpg`: `${this._baseImgPath}/${this.taxonomyVar}/${this.entityVar}_Med.jpg`) :
                `${this._baseImgPath}/${this.id}_Med.jpg`;
        }
        this._gPic = encodeURIComponent(this._gPic);
    }

    get gPic(): string {
        return this._gPic;
    }

}
